import { createSlice } from '@reduxjs/toolkit';

export type IFiles = {
  completedPartCount: number;
  content_size: number;
  created_at: string;
  created_by: string;
  db_id: string;
  file_host_id: number;
  hash: string;
  id: string;
  is_deleted: boolean;
  is_private: boolean;
  name: string;
  size: number;
  totalPartCount: number;
  type: string;
};

export type IDataDocument = {
  id: string;
  created_at: string;
  brief_content: string;
  details: {
    lang: string;
    files: [
      {
        completedPartCount: number;
        content_size: number;
        created_at: string;
        created_by: string;
        db_id: string;
        file_host_id: number;
        hash: string;
        id: string;
        is_deleted: boolean;
        is_private: boolean;
        name: string;
        size: number;
        totalPartCount: number;
        type: string;
      },
    ];
    state: string;
    attachments: [
      {
        id: string;
        hash: null;
        name: string;
        size: number;
        type: string;
        db_id: string;
        pdfUrl: string;
        created_at: string;
        created_by: string;
        is_delete: boolean;
        is_private: boolean;
        content_size: number;
        file_host_id: number;
      },
    ];
    db_recipients: [];
    internal_order_type_id: string;
    buyer: {
      account: string;
      address: string;
      based: string;
      director: string;
      mfo: string;
      nds_code: string;
      oked: string;
      org_name: string;
      tin: string;
    };
    seller: {
      account: string;
      address: string;
      based: string;
      director: string;
      mfo: string;
      nds_code: string;
      oked: string;
      org_name: string;
      tin: string;
    };
  };
  type_id: string;
  output_files: [];
  db_id: string;
  db: {
    name_ru: string;
    name_uz: string;
  };
  code: string;
  root: {
    document_reg_number: null;
    document_reg_date: null;
  };
  created_by: {
    id: string;
    full_name: string;
    work_phone: null;
    position_ru: string;
    position_uz: string;
  };
  rejected_tasks: [];
  signatures: [];
  linked_documents: null;
  has_qr: boolean;
  baseDocument: null;
  type: {
    internal_type: {
      name_ru: string;
      name_uz: string;
    };
    group_type: {
      type: {
        key: string;
        value: string;
      };
      name_ru: string;
      name_uz: string;
    };
    upper_group_type: {
      name_ru: string;
      name_uz: string;
    };
  };
  status: {
    code: string;
    text: string;
  };
  task_for_sign: {
    action_at: string;
    action_by: string;
    content: any;
    created_at: string;
    created_by: string;
    db_id: string;
    details: any;
    document_id: string;
    due_date: any;
    id: string;
    is_deleted: boolean;
    recipient: {
      db: {
        id: string;
        name_ru: string;
        name_uz: string;
      };
      department: {
        id: string;
        name_ru: string;
        name_uz: string;
      };
      user: {
        full_name: string;
        id: string;
      };
    };
    reject_id: any;
    sender: {
      db: {
        id: string;
        name_ru: string;
        name_uz: string;
      };
      department: {
        id: string;
        name_ru: string;
        name_uz: string;
      };
      user: {
        full_name: string;
        id: string;
      };
    };
    sign_id: '61531ab5ff10b900019bb478';
    status: number;
  };
};

type IData = {
  attorney_doc_id: string;
  attorney_document: IDataDocument;
  content: null;
  created_at: Date;
  created_by: string;
  current_doc_id: string;
  details: {
    lawsuitType: string;
    conclusionFiles: IFiles[];
  };
  done: boolean;
  done_at: Date | string;
  done_status: string;
  id: string;
  recipient_db: {
    id: string;
    name_ru: string;
    name_uz: string;
  };
  recipient_db_name: string;
  recipient_db_id: string;
  recipient_user: {
    id: string;
    first_name: string;
    last_name: string;
    middle_name: string;
    full_name: string;
  };
  reject: false;
  rejected_at: null;
  resend_at: null;
  response_document: IDataDocument;
  response_document_id: string;
  send_at: Date | string;
  sender_db: {
    id: string;
    name_uz: string;
    name_ru: string;
  };
  sender_user_id: string;
  status: {
    code: string;
    text: string;
  };
};

interface RequestCommandState {
  loading: boolean;
  data: IData;
}

let data;

const initialState: RequestCommandState = {
  loading: true,
  data,
};

export const lawSuitGetIdSlice = createSlice({
  name: 'lawSuitGetId',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setData: (state, action) => {
      // @ts-ignore
      state.data = action.payload;
    },
  },
});

export default lawSuitGetIdSlice.reducer;
